import AdverseEvents from './adverseEvents';
import Dashboard from './dashboard';
import DocumentsDirectories from './documents/directories';
import DocumentsDocuments from './documents/documents';
import DocumentsVersions from './documents/versions';
import Enquiries from './enquiries';
import Forms from './forms/forms';
import FormResponses from './forms/responses';
import FormVersions from './forms/versions';
import Notices from './notices';
import PermissionsCategories from './permissions/categories';
import PermissionsGates from './permissions/gates';
import PermissionsServiceUsers from './permissions/serviceUsers';
import PermissionsUsers from './permissions/users';
import Quoting from './quoting';
import Reports from './reports';
import Roster from './roster';
import RosterSettings from './rosterSettings';
import SupportWorkers from './supportWorkers';
import TrainingAttemptItems from './training/attemptItems';
import TrainingAttempts from './training/attempts';
import TrainingCourses from './training/courses';
import TrainingModuleAttachments from './training/moduleAttachments';
import TrainingModuleItems from './training/moduleItems';
import TrainingModules from './training/modules';
import TrainingModuleVersions from './training/moduleVersions';

export const load = (app) => {
	app.factory('AdverseEvents', AdverseEvents);
	app.factory('Dashboard', Dashboard);
	app.factory('DocumentsDirectories', DocumentsDirectories);
	app.factory('DocumentsDocuments', DocumentsDocuments);
	app.factory('DocumentsVersions', DocumentsVersions);
	app.factory('Enquiries', Enquiries);
	app.factory('Forms', Forms);
	app.factory('FormResponses', FormResponses);
	app.factory('FormVersions', FormVersions);
	app.factory('Notices', Notices);
	app.factory('PermissionsCategories', PermissionsCategories);
	app.factory('PermissionsGates', PermissionsGates);
	app.factory('PermissionsServiceUsers', PermissionsServiceUsers);
	app.factory('PermissionsUsers', PermissionsUsers);
	app.factory('Quoting', Quoting);
	app.factory('Reports', Reports);
	app.factory('Roster', Roster);
	app.factory('RosterSettings', RosterSettings);
	app.factory('SupportWorkers', SupportWorkers);
	app.factory('TrainingAttemptItems', TrainingAttemptItems);
	app.factory('TrainingAttempts', TrainingAttempts);
	app.factory('TrainingCourses', TrainingCourses);
	app.factory('TrainingModuleAttachments', TrainingModuleAttachments);
	app.factory('TrainingModuleItems', TrainingModuleItems);
	app.factory('TrainingModules', TrainingModules);
	app.factory('TrainingModuleVersions', TrainingModuleVersions);
};


// WEBPACK FOOTER //
// ./src/js/factories/loader.js